module.exports = __webpack_public_path__ + "static/img/cj.eb1a83e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cj.png
// module id = xWcJ
// module chunks = 1